import { ddRumAction } from '@/utils/datadog';
import { GeoLogRumTypes } from '@/logic/geolocation/login-geo-types.types';

export const loginGeoRum = (type: GeoLogRumTypes, payload: { region?: string; product?: string; silent?: boolean }) => {
    switch (type) {
        case GeoLogRumTypes.PROGRESS:
            return ddRumAction({
                name: '[GEOLOCATION]: Geolocation in progress',
                description: 'Login geolocation in progress.',
                context: {
                    region: payload?.region,
                    product: payload?.product,
                    silent: payload?.silent ?? false
                },
                use_case: 'GLOBAL'
            });
        case GeoLogRumTypes.PASSED:
            return ddRumAction({
                name: '[GEOLOCATION]: Geolocation passed',
                description: 'Login geolocation passed.',
                context: {
                    region: payload?.region,
                    product: payload?.product,
                    silent: payload?.silent ?? false
                },
                use_case: 'GLOBAL'
            });
        case GeoLogRumTypes.REJECTED:
            return ddRumAction({
                name: '[GEOLOCATION]: Geolocation rejected',
                description: 'Login geolocation rejected.',
                context: {
                    region: payload?.region,
                    product: payload?.product,
                    silent: payload?.silent ?? false
                },
                use_case: 'GLOBAL'
            });
        case GeoLogRumTypes.FAILED:
            return ddRumAction({
                name: '[GEOLOCATION]: Geolocation failed',
                description: 'Login geolocation failed.',
                context: {
                    region: payload?.region,
                    product: payload?.product,
                    silent: payload?.silent ?? false
                },
                use_case: 'GLOBAL'
            });
        case GeoLogRumTypes.INVALIDATED:
            return ddRumAction({
                name: '[GEOLOCATION]: Geolocation invalidated',
                description: 'Login geolocation invalidated.',
                context: {
                    region: payload?.region,
                    product: payload?.product,
                    silent: payload?.silent ?? false
                },
                use_case: 'GLOBAL'
            });
        case GeoLogRumTypes.INIT:
            return ddRumAction({
                name: '[GEOLOCATION]: Geolocation init',
                description: 'Login geolocation init.',
                context: {
                    region: payload?.region,
                    product: payload?.product,
                    silent: payload?.silent ?? false
                },
                use_case: 'GLOBAL'
            });
        case GeoLogRumTypes.CALLBACK_SET:
            return ddRumAction({
                name: '[GEOLOCATION]: Geolocation callback set',
                description: 'Login geolocation callback set.',
                context: {
                    region: payload?.region,
                    product: payload?.product,
                    silent: payload?.silent ?? false
                },
                use_case: 'GLOBAL'
            });
        case GeoLogRumTypes.CONFIG_SET:
            return ddRumAction({
                name: '[GEOLOCATION]: Geolocation config set',
                description: 'Login geolocation config set.',
                context: {
                    region: payload?.region,
                    product: payload?.product,
                    silent: payload?.silent ?? false
                },
                use_case: 'GLOBAL'
            });
        default:
            return null;
    }
};
